import useFetchAISummaryList from "../../hooks/useFetchAISummaryList";
import Title from "../Fields/Title";

import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";

export default function AISummaryContainer() {
  useFetchAISummaryList();

  return (
    <div className="flex h-screen w-[100%] flex-col gap-4 rounded-[14px] bg-white px-[26px] py-[42px] shadow-md">
      <Title />
      <div className="flex h-full w-full flex-row items-stretch gap-4">
        <LeftPanel />
        <RightPanel />
      </div>
    </div>
  );
}
